export * from './secondary-passenger-form-data';
export * from './secondary-passenger-detail-form.controller';
export * from './secondary-passenger-detail-form.component';
